import React, { Component } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser'

import { ContentHeader, StaticBox, LinkedInput, Modal, LoadingIndicator } from 'components/basic'

import { notify, date } from 'helpers'
import http from 'API/http'

const priorities = [
  {
    name: 'CRITICAL',
    value: 'CRITICAL'
  },
  {
    name: 'MEDIUM',
    value: 'MEDIUM'
  }
]
class Ticket extends Component {
  constructor (props) {
    super(props)
    this.state = {
      ticket: null,
      access: {},
      contactInfo: '',
      contactModal: false,
      users: []
    }
  }
  async componentDidMount () {
    var err, res
    var errAccess, resAccess
    [err, res] = await http.get('2.3/tickets/' + this.props.match.params.ticketId)
    if (err) return notify.alert('', err.message, 'error')
    this.setState({ticket: {...res.data, title: ReactHtmlParser(res.data.title)}})
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: res.data.title
    });
    [errAccess, resAccess] = await http.get('2.3/accesses/' + res.data.accessId)
    if (errAccess) return false
    this.setState({access: resAccess.data})
  }
  async componentWillReceiveProps (nextProps) {
    if (this.props.match.params.ticketId === nextProps.match.params.ticketId) return
    var err, res
    var errAccess, resAccess
    [err, res] = await http.get('2.3/tickets/' + nextProps.match.params.ticketId)
    if (err) return notify.alert('', err.message, 'error')
    this.setState({ticket: {...res.data, title: ReactHtmlParser(res.data.title)}})
    this.props.dispatch({
      type: 'SET_PAGE_TITLE',
      payload: res.data.title
    });
    [errAccess, resAccess] = await http.get('2.3/accesses/' + res.data.accessId)
    if (errAccess) return false
    this.setState({access: resAccess.data})
  }
  getAssignee (assignee) {
    switch (assignee) {
      case 0:
        return 'CO'
      case 1:
        return 'SP'
      default:
        return assignee
    }
  }
  getStatus (status) {
    switch (status) {
      case 0:
        return 'NEW'
      case 1:
        return 'OPEN'
      case 2:
        return 'CLEARED'
      case 3:
        return 'CLOSED'
      default:
        return status
    }
  }
  async getContactInfo () {
    var err, res
    if (this.props.access !== 'FLOW') return
    [err, res] = await http.get('2.3/tickets/' + this.state.ticket.ticketRef + '/contactinfo')
    if (err) return
    this.setState({contactInfo: res.data.contactInfo || '', contactModal: true})
  }
  async putContactInfo () {
    var err, res
    if (this.props.access !== 'FLOW') return
    [err, res] = await http.put('2.3/tickets/' + this.state.ticket.ticketRef + '/contactinfo', {
      contactInfo: this.state.contactInfo
    })
    if (err) {
      this.setState({contactModal: false})
      return notify.warn(res.data.cause)
    }
    this.setState({contactInfo: res.data.contactInfo || '', contactModal: false})
  }
  async updateTicket (update) {
    if (!update) {
      if (!this.textArea.value) return notify.alert('', 'You have to write a comment.', 'warning')
    }
    var err, res
    [err, res] = await http.put('2.3/tickets/' + this.state.ticket.ticketRef, {
      description: this.textArea.value,
      priority: this.state.ticket.priority,
      action: 'NOTIFY'
    })

    if (err) return notify.alert('Your comment was not saved, try again', '', 'error')
    let _ticket = await http.get('2.3/tickets/' + this.props.match.params.ticketId)
    err = _ticket[0]
    res = _ticket[1]
    if (err) return notify.alert('', err.message, 'error')
    notify.success('Your changes has been saved')
    this.textArea.value = ''
    this.setState({ticket: {...res.data, title: ReactHtmlParser(res.data.title)}})
    this.forceUpdate()
  }
  async closeTicket () {
    var err, res
    [err, res] = await http.put('2.3/tickets/' + this.state.ticket.ticketRef, {
      description: null,
      priority: this.state.ticket.priority,
      action: 'CLOSE'
    })
    if (err) return console.log(err)
    notify.alert('The ticket has been closed', '', 'success')
    this.setState({ticket: {...res.data, title: ReactHtmlParser(res.data.title)}})
  }
  async openTicket () {
    var err, res
    [err, res] = await http.put('2.3/tickets/' + this.state.ticket.ticketRef, {
      description: '',
      priority: this.state.ticket.priority,
      action: 'REOPEN'
    })
    if (err) return notify.alert('The ticket could not be reopened', '', 'error')
    notify.alert('The ticket has been reopened', '', 'success')
    this.setState({ticket: {...res.data, title: ReactHtmlParser(res.data.title)}})
  }
  render () {
    if (!this.state.ticket) return <LoadingIndicator loadingMessage={'Fetching ticket'} visible />
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Ticket' subtitle={this.state.ticket.ticketRef} buttons={[{ icon: 'fa-home', event: () => (window.location.hash = '/access/' + this.state.access.accessId) }, { icon: 'fa-arrow-left', event: () => (window.location.hash = '/ticket') }]} />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='home' title={`${!this.state.access.streetName ? (this.state.ticket.title + ' - ' + this.state.ticket.ticketRef) : ''} ${this.state.access.streetName || ''} ${this.state.access.streetNumber || ''} ${this.state.access.mduApartmentNumber || ''} ${this.state.access.mduDistinguisher || ''}`}>
            <div className='row'>
              <div className='col-md-3'>
                <label>Title</label>
                <LinkedInput context={this} path='ticket.title' editable={false} />
              </div>
              <div className='col-md-3'>
                <label>Priority</label>
                <Select
                  value={this.state.ticket.priority}
                  onChange={e => this.setState({ticket: {...this.state.ticket, priority: e.value}})}
                  options={priorities}
                  valueKey='value'
                  labelKey='name'
                  disabled={this.state.ticket.state.status === 'CLOSED'}
                  clearable={false}
                />
              </div>
              <div className='col-md-3'>
                <label>Your Internal Reference</label>
                <LinkedInput context={this} path='ticket.spReference' editable={false} />
              </div>
              <div className='col-md-3'>
                <label>Status</label>
                <input type='text' value={this.getStatus(this.state.ticket.state.status)} disabled className='form-control' />
              </div>
            </div>
            <div className='row'>
              <div className='col-md-3'>
                <label>Access ID</label>
                <LinkedInput context={this} editable={false} path='access.accessId' />
              </div>
              <div className='col-md-3 form-group'>
                <label>Contact Info</label>
                <div className='input-group'>
                  <input type='text' className='form-control' value={'Click button to view info'} disabled />
                  <span className='input-group-btn'>
                    <button className='btn btn-primary' type='button'
                      onClick={() => this.getContactInfo()}><i className='fa fa-eye' />
                    </button>
                  </span>
                </div>
              </div>
              {this.state.ticket.assignee && <div className='col-md-3'>
                <label>Assigned to</label>
                <LinkedInput context={this} editable={false} path='ticket.assignee' />
              </div>}
            </div>
            <hr />
            {this.state.ticket.state.status !== 'CLOSED' &&
            <div className='row'>
              <div className='col-sm-6'>
                <a onClick={e => this.closeTicket()} className='btn btn-danger'>Close Ticket</a>
              </div>
              <div className='col-sm-6 text-right'>
                <a onClick={e => this.updateTicket(true)} className='btn btn-primary'>Save</a>
              </div>
            </div>}
            {this.state.ticket.state.status === 'CLOSED' && this.props.access !== 'FLOW' &&
            <div className='row'>
              <div className='col-sm-6' />
              <div className='col-sm-6 text-right'>
                <a onClick={e => this.openTicket()} className='btn btn-primary'>Reopen Ticket</a>
              </div>
            </div>}
          </StaticBox>
        </div>
        <div className='row'>
          <StaticBox cols={12} icon='commenting-o' title='Comments'>
            <div className='row'>
              <div className='col-md-12'>
                {this.state.ticket.state.status !== 'CLOSED' &&
                <div>
                  <label>Add comment</label>
                  <textarea ref={ref => (this.textArea = ref)} style={{width: '100%'}} rows='5' className='form-control' />
                  <hr />
                </div>
                }
                {this.state.ticket.state.status !== 'CLOSED' &&
                <div className='row'>
                  <div className='col-sm-6' />
                  <div className='col-sm-6 text-right'>
                    <a onClick={e => this.updateTicket()} className='btn btn-primary'>Add Comment</a>
                  </div>
                </div>}
                <hr />
                {this.state.ticket.log.map(comment => {
                  if (!comment.comment) return null
                  return (
                    <div key={comment.eventId}>
                      <label>{comment.creatorUserName} {date.format(comment.timestamp * 1000)} {this.state.ticket.title} {comment.state.assignedTo ? 'Assigned to ' + this.getAssignee(comment.state.assignedTo) : '' }</label>
                      <pre style={{wordWrap: 'break-word', whiteSpace: 'pre-wrap'}}>{ReactHtmlParser(comment.comment)}</pre>
                    </div>
                  )
                })}
              </div>
            </div>
          </StaticBox>
        </div>
        <Modal title={'Contact Info'} isOpen={this.state.contactModal} close={() => this.setState({contactModal: false})} buttons={[
          { text: 'Close', event: () => this.setState({contactModal: false}) },
          { text: 'Save', event: () => this.putContactInfo(), hidden: !this.state.contactEdit },
          { text: 'Edit', event: () => this.setState({contactEdit: true}), hidden: this.state.contactEdit }
        ]}>
          <div className='content-wrapper'>
            <textarea className='form-control' maxLength='10000' style={{height: '150px'}} onChange={e => this.setState({contactInfo: e.target.value})} value={this.state.contactInfo} readOnly={!this.state.contactEdit} />
          </div>
        </Modal>

      </div>
    )
  }
}
//eslint-disable-next-line
Ticket = connect(state => state.siteReducer)(Ticket)
export default Ticket



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/ticket/ticket.js